import React from "react";

import Icon1 from "../../../assets/icons/empty-wallet-tick.png";
import Icon2 from "../../../assets/icons/money-recive.png";
import Icon3 from "../../../assets/icons/wallet-money.png";
const StakeWithD3 = () => {
  const data = [
    {
      icon: Icon1,
      btnText: "Register Wallet",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit Maecenas augue nulla.lit Maecenas augue nulla.",
    },
    {
      icon: Icon2,
      btnText: "Earn Returns",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit Maecenas augue nulla.lit Maecenas augue nulla.",
    },
    {
      icon: Icon3,
      btnText: "Buy DEFI",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit Maecenas augue nulla.lit Maecenas augue nulla.",
    },
  ];
  return (
    <section className="py-10 pb-40">
      <div className="container">
        <h2 className="text-center text-[30px] md:text-[44px] font-semibold">
          Easily stake with <span className="text-primary "> D3</span>
        </h2>
        <p className="text-gray mx-auto max-w-md text-base md:text-lg mt-3 text-center ">
          Stake in multiple crypto & keep track of your investments
        </p>

        <div className="grid md:grid-cols-3 gap-20 md:gap-20 mt-20 relative">
          <div className="absolute  h-full md:h-[1px] w-[1px] md:w-full left-1/2 md:left-auto md:top-1/2 bg-primary  md:translate-x-0 md:-translate-y-1/2"></div>
          {data.map((val, i) => (
            <div key={i} className=" bg-dark-500 py-6 px-4 rounded-xl  z-10">
              <button className="grid grid-flow-col justify-center items-center gap-2 uppercase text-sm mx-auto border-2 border-dark-400 p-3 rounded-[20px] bg-[#161616] px-6">
                <img src={val.icon} alt="" />
                <p>{val.btnText}</p>
              </button>
              <p className=" text-gray text-center mt-6">{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StakeWithD3;
